import { render, staticRenderFns } from "./MosaicWidget.vue?vue&type=template&id=a1327b64&scoped=true"
import script from "./MosaicWidget.vue?vue&type=script&lang=js"
export * from "./MosaicWidget.vue?vue&type=script&lang=js"
import style0 from "./MosaicWidget.vue?vue&type=style&index=0&id=a1327b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1327b64",
  null
  
)

export default component.exports